import { SessionKeyEnum } from "../../../Enumeration/SessionKeyEnum";
import Home from "../../../Pages/Home";

function HomeProtectedRoute() {
  const sessionToken = sessionStorage.getItem(SessionKeyEnum.AppKey);
  // const [, , , , , , getConfig] = useResource();
  // const { showAlert } = useAlertContext();
  // No token anywhere → go to login
  if (!sessionToken) {
    // showAlert(
    //   "Error",
    //   OK,
    //   "Session has expired. You will be redirected to Login Page.",
    //   () => {
    //     getConfig().then((res) => {
    //       if (res) {
    //         window.location.href = res?.rd_resume_popup;
    //       }
    //     });
    //   },
    // );

    return null;
  }
  return <Home />;
}

export default HomeProtectedRoute;
